import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classes from './ResourceCardPanel.module.scss';
import ResourceAccessInstruction, { rendersInstruction } from '@/components/Resources/ResourceAccessInstruction/ResourceAccessInstruction';
import { Col, Container, Row } from 'react-bootstrap';
import t from '@/utils/Language/ResourceCard-translations';
import { applyFilters } from '@/utils/filters';
import { resourceHelpers } from '@/utils/helpers';

const ContactPanel = ({ resource, project }, ...props) => {
  const isOrganization = resource.resource_type === 'Organization';

  if (isOrganization) {
    const primaryPhone = resource.phones?.find((p) => p.is_primary) || resource.phones?.[0];
    const primaryEmail = resource.emails?.find((e) => e.is_primary) || resource.emails?.[0];

    return (
      <Container className={classes.resourceCardPanel}>
        {primaryPhone && (
          <Row className={classes.accessInstructions}>
            <Col xs="12">
              <div className={classes.contactItem}>
                <FontAwesomeIcon icon={['fas', 'phone']} className={classes.contactIcon} size="xl" />
                <a href={`tel:${primaryPhone.digits}`}>
                  {t('Call')} {applyFilters(['phone'], primaryPhone.digits)}
                  {primaryPhone.phone_type && <span> ({primaryPhone.phone_type})</span>}
                </a>
              </div>
            </Col>
          </Row>
        )}
        {primaryEmail && (
          <Row className={classes.accessInstructions}>
            <Col xs="12">
              <div className={classes.contactItem}>
                <FontAwesomeIcon icon={['fas', 'envelope']} className={classes.contactIcon} size="xl" />
                <a href={`mailto:${primaryEmail.email}`}>
                  {t('Email')} {primaryEmail.email}
                  {resourceHelpers.emailMeta(primaryEmail) && <span> ({resourceHelpers.emailMeta(primaryEmail)})</span>}
                </a>
              </div>
            </Col>
          </Row>
        )}
        {resource.website && (
          <Row className={classes.accessInstructions}>
            <Col xs="12">
              <div className={classes.contactItem}>
                <FontAwesomeIcon icon={['fas', 'link']} className={classes.contactIcon} size="xl" />
                <a href={resource.website} target="_blank" rel="noreferrer">
                  {t('View website')}
                </a>
              </div>
            </Col>
          </Row>
        )}
      </Container>
    );
  }

  return (
    <Container className={classes.resourceCardPanel}>
      <Row>
        <Col xs="12" className="mt-2">
          <span className={classes.highlight}>{t('What to do next')}</span>
        </Col>
      </Row>
      {resource.access_instructions?.length && (
        <Row className={classes.accessInstructions}>
          {resource.access_instructions.filter(rendersInstruction).map((access_instruction, index) => (
            <Col xs="12" md="6" lg="4" key={index}>
              <ResourceAccessInstruction instruction={access_instruction} addressBlockLayout="inline" resource={resource} project={project} />
            </Col>
          ))}
        </Row>
      )}
    </Container>
  );
};

export default ContactPanel;
